import {z} from 'zod'
import {SubscriptionFeatures} from './SubscriptionFeatures.js'
import {StripePriceId} from '../stripe/index.js'

export const SubscriptionInterval = z.enum(['day', 'week', 'month', 'year'])
export type SubscriptionInterval = z.infer<typeof SubscriptionInterval>

export const SubscriptionPrice = z.object({
  id: StripePriceId,
  price: z.number(),
  monthlyPrice: z.number(),
  interval: SubscriptionInterval,
  trialDays: z.number(),
})
export type SubscriptionPrice = z.infer<typeof SubscriptionPrice>

export const Subscription = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullish(),
  isSubscribed: z.boolean(),
  subscriptionEndDate: z.string().nullish(),
  isCanceled: z.boolean(),
  isTrial: z.boolean(),
  features: SubscriptionFeatures,
  prices: SubscriptionPrice.array(),
})
export type Subscription = z.infer<typeof Subscription>
